<template>
<div class="chapter">
<div class="inner_page">
<p class="p5">Thank you to Donna, Kelly, Stella,</p>
<p class="p0">and everyone else in my beta group</p>
<p class="p0">who helped me with both this book</p>
<p class="p0">and the logic of this whole universe.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?565f1058